export class FileHelper {
  static getFileName(order, product) {
    const version = product.version ? '-' + product.version : '';
    const format = product.dimension.description
      .replace(/,00/g, '')
      .replace(/:/g, '')
      .replace(/\r?\n|\r/g, ' ');
    const oId = order.transactionId;
    const qty = product.quantity;
    const vLabel = product.isVersion ? '-' + product.productName : version;
    return oId + '-' + format + '-' + qty + 'ex' + vLabel + '.pdf';
  }
}
